var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "socials-icon/dark/default/Linkedin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.44117 2.5C2.64548 2.5 2 3.12583 2 3.89684V20.6036C2 21.3747 2.64556 22 3.44117 22H20.0588C20.8548 22 21.5 21.3746 21.5 20.6034V3.89684C21.5 3.12583 20.8548 2.5 20.0588 2.5H3.44117ZM7.9257 10.04V18.819H5.00771V10.04H7.9257ZM8.11804 7.32502C8.11804 8.16748 7.48467 8.84161 6.46732 8.84161L6.4482 8.84153C5.46886 8.84153 4.83572 8.16741 4.83572 7.32495C4.83572 6.46337 5.48798 5.80806 6.48667 5.80806C7.48467 5.80806 8.099 6.46337 8.11804 7.32502ZM12.4586 18.819H9.54085C9.54085 18.819 9.57909 10.8639 9.54101 10.0403H12.4588V11.2829C12.8467 10.6849 13.5409 9.8342 15.0887 9.8342C17.0084 9.8342 18.4478 11.089 18.4478 13.7854V18.819H15.5301V14.123C15.5301 12.9427 15.1076 12.1377 14.052 12.1377C13.2457 12.1377 12.7656 12.6806 12.5547 13.205C12.4777 13.3922 12.4586 13.6549 12.4586 13.9169V18.819Z",
    fill: "#5C5F66"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.2dc887f250b8706b0a5bc42d0362744f.svg";
export { ForwardRef as ReactComponent };